export const MEDIA = {
  logo: "/logo.png",
  heroVideo: "https://videos.pexels.com/video-files/7578547/7578547-uhd_2560_1440_30fps.mp4",
  bandVideo: "https://videos.pexels.com/video-files/7578548/7578548-uhd_3840_2160_30fps.mp4",
  heroPoster:
    "https://images.unsplash.com/photo-1635108201018-94bbbfac4a79?crop=entropy&cs=srgb&fm=jpg&q=85&w=2000",
  extHero:
    "https://images.unsplash.com/photo-1649176061656-9eb926d84786?crop=entropy&cs=srgb&fm=jpg&q=85&w=2000",
  extAlt:
    "https://images.pexels.com/photos/7031407/pexels-photo-7031407.jpeg?auto=compress&cs=tinysrgb&dpr=2&w=1600",
  interior:
    "https://images.unsplash.com/photo-1648475236583-2e25a6cbf3bd?crop=entropy&cs=srgb&fm=jpg&q=85&w=1600",
  interior2:
    "https://images.unsplash.com/photo-1638885930125-85350348d266?crop=entropy&cs=srgb&fm=jpg&q=85&w=1600",
  aerial:
    "https://images.unsplash.com/photo-1755114203680-d39d95efa82c?crop=entropy&cs=srgb&fm=jpg&q=85&w=1600",
  aerial2:
    "https://images.unsplash.com/photo-1635111057505-3b7dcc2b72fb?crop=entropy&cs=srgb&fm=jpg&q=85&w=1600",
};

export const SPECTORA_URL = "https://app.spectora.com/home-inspectors/my-inspection-company-bf81d1d015/schedule?iframe=1";

export const SERVICES = [
  {
    id: "buyer",
    num: "01",
    title: "Residential Inspection",
    tag: "Pre-Purchase",
    desc: "A meticulous top-to-bottom evaluation of every major system before you close — structure, roof, electrical, plumbing and HVAC.",
    image: MEDIA.interior,
  },
  {
    id: "listing",
    num: "02",
    title: "Pre-Drywall Inspection",
    tag: "New Build",
    desc: "A mid-construction check of framing, plumbing, electrical and structural rough-ins before drywall hides them.",
    image: "/box2-home.jpg",
  },
  {
    id: "roof",
    num: "03",
    title: "Drone Technology/On-Roof Inspection",
    tag: "Aerial + On-Roof",
    desc: "Drone Technology and On-Roof Inspections available.",
    image: MEDIA.aerial,
  },
  {
    id: "thermal",
    num: "04",
    title: "Commercial Inspection",
    tag: "Commercial",
    desc: "Know the property before you invest. Our commercial inspections evaluate every major system — roofing, structure, electrical, plumbing, HVAC and more — so you move forward with confidence.",
    image: "/box4-commercial.jpg",
  },
];

export const STEPS = [
  {
    num: "01",
    title: "Book Online",
    desc: "Schedule your inspection in minutes. We confirm same-day and align around your closing timeline.",
  },
  {
    num: "02",
    title: "On Site",
    desc: "Your certified inspector evaluates and documents over 2,000 components, conditions and inspection points throughout the home. This thorough evaluation brings clarity and confidence to your home buying decision.",
  },
  {
    num: "03",
    title: "Review of Findings",
    desc: "This on-site or virtual review of the inspection is a valuable piece of the process. Ask any questions you may have and get your inspector's professional opinion on findings and how to interpret them.",
  },
  {
    num: "04",
    title: "Inspection Report",
    desc: "Your easy-to-understand report provides prioritization, documentation and direction on how to proceed with each finding. Reports are published the same day as the on-site inspection.",
  },
];

export const STATS = [
  { value: 2500, suffix: "+", label: "Homes inspected across Georgia" },
  { value: 2000, suffix: "+", label: "Point comprehensive inspection checklist" },
  { value: 30, suffix: "+", label: "Years of combined field experience" },
  { text: "Same Day", label: "Turnaround on your full digital report" },
];
